

function buildKeyValue({ key, value }) {
    if(value !== null && typeof value === "object") {
        return serialize(value, key);
    };

    return encodeURIComponent(key) + "=" + encodeURIComponent(value);
};

function handleParams(accumulator, { key, prefix, obj }) {
    if (!obj.hasOwnProperty(key)) {
        return accumulator;
    };

    const value = obj[key];
    const name = prefix ? `${prefix}[${key}]` : key;
    const param = buildKeyValue({ key: name, value });

    return accumulator.concat(param);
};

export function serialize({ object = {}, prefix }) {
    
    return Object.keys(object).reduce((acctr, key) => {
        
        return handleParams(acctr, { 
            key, 
            prefix, 
            obj: object 
        });
    }, []).join("&");
};